import { faCircleNotch, faGift } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Toolbar from "components/Toolbar";
import dayjs from "dayjs";
import useToastContext from "hooks/useToastContext";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { apiGet, apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";
import AddGiftCard from "./AddGiftCard";
import gift_cards_config from "./config";

function GiftCards() {
  const { t } = useTranslation();
  const notification = useToastContext();
  const { register, handleSubmit } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const [loading, setLoading] = useState(false);
  const [sentGiftCards, setSentGiftCards] = useState([]);
  const [showAddGiftCardBottomSheet, setShowAddGiftCardBottomSheet] = useState(false);

  const getSentGiftCards = async () => {
    setSentGiftCards([])
    try {
      const path = pathObj.sentGiftCards;
      const result = await apiGet(path);
      setSentGiftCards(result.data.results.docs);
    } catch (error) {}
  };

  useEffect(() => {
    getSentGiftCards();
  }, []);

  const onUseGiftCardSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await apiPost(pathObj.redeemGiftCard, { code: data.code });
      if (res.data.success) {
        notification.success(res.data.message || t("OPERATION_SUCCESS"));
      } else {
        notification.error(res.data.message);
      }
    } catch (err) {}
    setLoading(false);
  };

  return (
    <>
      <Toolbar title={t("NAV_GIFT_CARD")} showBackBtn={true} />
      <div className="flex flex-col w-full justify-center items-center">
        <div className="w-full md:w-[25rem] mt-3 p-4">
          <form onSubmit={handleSubmit(onUseGiftCardSubmit)}>
            <div className="mt-2 mx-2">
              <div className="text-lg font-medium  mt-5 mb-2">{t("ENTER_RECEIVED_GIFT_CARD")}</div>
              <input
                type="text"
                id="code"
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("CODE")}
                onKeyDown={(e) => {
                  e.target.value = e.target.value.trim();
                }}
                {...register("code", {
                  required: "",
                })}
                required
              />

              <div className="w-full mt-5">
                {loading ? (
                  <div className="btn btn_theme w-full flex items-center justify-center p-3">
                    <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
                  </div>
                ) : (
                  <button className="btn btn_theme w-full text-white" type="submit">
                    {t("O_ADD_MONEY")}
                  </button>
                )}
              </div>
            </div>
          </form>

          <div className="flex justify-between w-full my-5 px-2">
            <div className="text-lg font-medium">{t("GIFT_CARD_SEND")}</div>
            <Link to={"/gift-cards/history"} className="text-lg font-medium text-primary">
              {t("O_ALL")}
            </Link>
          </div>

          <button
            className="btn btn_theme w-full text-white"
            onClick={() => {
              setShowAddGiftCardBottomSheet(true);
            }}
          >
            {t("GIFT_CARD_ADD")}
          </button>
          {showAddGiftCardBottomSheet && (
            <AddGiftCard
              onClose={() => {
                setShowAddGiftCardBottomSheet(false);
              }}
              onNewCard={() => {
                getSentGiftCards()
              }}
            />
          )}
          {sentGiftCards.map((it) => {
            const config = gift_cards_config.find((it2) => it2.type === it.title);
            return (
              <div key={it._id} className="bg-card p-4 flex justify-start items-center gap-3 mt-3 cursor-pointer">
                <FontAwesomeIcon icon={config?.icon || faGift} size="xl" className={`${config?.color || "text-white"}`} />
                <div className="flex justify-between items-center w-full">
                  <div className="flex flex-col">
                    <span className="font-medium text-white">{t(config?.title || '')}</span>
                    <span className="text-white font-medium">@{it.receiver_username}</span>
                  </div>
                  <span className="text-white font-medium">{dayjs(it.delivery_date).format("DD/MM/YYYY")}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default GiftCards;
